import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Define RTL languages
const RTL_LANGUAGES = ['fa', 'ar', 'he'];

i18n
  // Load translation using http -> see /public/locales
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'fa'],
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already safes from XSS
    },

    // Backend configuration
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Namespaces
    ns: ['common', 'dashboard', 'wallet', 'transactions', 'settings', 'login', 'networks', 'coinNetworks', 'app', 'auth', 'coins', 'status', 'rpc', 'queue', 'indexer', 'debug', 'descriptions.deposit', 'descriptions.withdrawal'],
    defaultNS: 'common',

    // Enable returnObjects for nested translation objects
    returnObjects: true,

    // React settings
    react: {
      useSuspense: true,
    },
  });

// Add language change event handler to update document direction
i18n.on('languageChanged', (lng) => {
  // Set document direction based on language
  const dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;

  // You can also add a class to the body for additional styling
  if (dir === 'rtl') {
    document.body.classList.add('rtl');
    document.body.classList.remove('ltr');
  } else {
    document.body.classList.add('ltr');
    document.body.classList.remove('rtl');
  }
});

export default i18n;
